import React, { useEffect, useState } from "react";
import { Accordion } from 'react-bootstrap';
import Header2 from '../Header2/header2';
import { Container, Row, Breadcrumb, ListGroup } from "react-bootstrap";
import Footer from "../Footer/footer";
import axios from "axios";
import { API_BASE_URL, IMAGE_URL, IMAGE_URL_UPLOAD, IMAGE_URL_BUSINESS } from "@/config/serverApiConfig";
import dateFormat from 'dateformat';


import Carousel from "react-bootstrap/Carousel";
import UpdateBusiness from "../Update_Business/UpdateBusiness";
const RequestBusinessHistory = () => {

    let [data, setData] = useState([])
    
    const token = localStorage.getItem("token");
    let config = {
        headers: {
            'x-access-token': `${token}`
        }
    }
    let images = []
    
    useEffect(() => {
        axios.post(`${API_BASE_URL}business-listing/request-business`, {}, config)
            .then(res => {
              // console.log(res.data.result);
              setData(res.data.result)
              // data.map check if image is null then set image to default image
              res.data.result.map(item => {
                if (item.image == null) {
                  images.push(IMAGE_URL_BUSINESS+"default.png")
                } else {
                  images.push(IMAGE_URL_BUSINESS + item.image)
                }
              }
              )
                console.log(data)
                
                    res.data.result.map(item => {
                      
                        item.images.map(image => {
                            
                           // `${IMAGE_URL_UPLOAD}${image}`
                            images.push(`${IMAGE_URL_UPLOAD}${image}`)
                        }
                        )
                    }
                    )
                          


            })
            .catch(err => {

            });
    }, []);






    return (
        <>
            <Header2 />
            <Container className="request-business-history-sec pb-5 min-height-g">
                <Breadcrumb className="pt-5 pb-4">
                    <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                    <Breadcrumb.Item active>My Businesses</Breadcrumb.Item>
                </Breadcrumb>
                <Row>

                    <Accordion defaultActiveKey={['0']}>
                        {data.map((item, i) => {
                            return (
                              <Accordion.Item
                                eventKey={i}
                                key={i}
                                className="mb-4"
                              >
                                <Accordion.Header>
                                  <span className="rbh_icon"></span>{" "}
                                  {item.category_id.name}{" "}
                                  {item.status
                                    ? " > Approved"
                                    : "note" in item && item.status == false
                                    ? " > Disapproved"
                                    : " > Pending"}{" "}
                                  <div className="rbh_edit"></div>
                                  <span className="rbh_date">
                                    Request On:{" "}
                                    {dateFormat(item.created, "mmmm dS, yyyy")}
                                  </span>
                                </Accordion.Header>

                                <Accordion.Body className="pt-0">
                                  <Row>
                                    <ListGroup className="col-lg-4">
                                      <ListGroup.Item className="d-flex border-0 py-0">
                                        <ListGroup.Item className="col-sm-4 fw-bold border-0">
                                          Business Category
                                        </ListGroup.Item>
                                        <ListGroup.Item className="col-sm-1 ps-0 pe-5 border-0 text-center">
                                          :
                                        </ListGroup.Item>
                                        <ListGroup.Item className="col-sm-4 border-0">
                                          {item.category_id.name}
                                        </ListGroup.Item>
                                      </ListGroup.Item>
                                      <ListGroup.Item className="d-flex border-0 py-0">
                                        <ListGroup.Item className="col-sm-4 fw-bold border-0">
                                          Sub Categories
                                        </ListGroup.Item>
                                        <ListGroup.Item className="col-sm-1 ps-0 pe-5 border-0 text-center">
                                          :
                                        </ListGroup.Item>
                                        <ListGroup.Item className="col-sm-4 border-0">
                                          {item.subcategory_id
                                            ? item.subcategory_id.name
                                            : "N/A"}
                                        </ListGroup.Item>
                                      </ListGroup.Item>
                                      <ListGroup.Item className="d-flex border-0 py-0">
                                        <ListGroup.Item className="col-sm-4 fw-bold border-0">
                                          Company Name{" "}
                                        </ListGroup.Item>
                                        <ListGroup.Item className="col-sm-1 ps-0 pe-5 border-0 text-center">
                                          :
                                        </ListGroup.Item>
                                        <ListGroup.Item className="col-sm-4 border-0">
                                          {item.companyName}
                                        </ListGroup.Item>
                                      </ListGroup.Item>
                                      <ListGroup.Item className="d-flex border-0 py-0">
                                        <ListGroup.Item className="col-sm-4 fw-bold border-0">
                                          Name of PoC{" "}
                                        </ListGroup.Item>
                                        <ListGroup.Item className="col-sm-1 ps-0 pe-5 border-0 text-center">
                                          :
                                        </ListGroup.Item>
                                        <ListGroup.Item className="col-sm-4 border-0">
                                          {item.nameOfPoc}
                                        </ListGroup.Item>
                                      </ListGroup.Item>
                                      <ListGroup.Item className="d-flex border-0 py-0">
                                        <ListGroup.Item className="col-sm-4 fw-bold border-0">
                                          Email of POC
                                        </ListGroup.Item>
                                        <ListGroup.Item className="col-sm-1 ps-0 pe-5 border-0 text-center">
                                          :
                                        </ListGroup.Item>
                                        <ListGroup.Item className="col-sm-4 border-0">
                                          {item.emailOfPoc}
                                        </ListGroup.Item>
                                      </ListGroup.Item>
                                      <ListGroup.Item className="d-flex border-0 py-0">
                                        <ListGroup.Item className="col-sm-4 fw-bold border-0">
                                          Mobile of PoC{" "}
                                        </ListGroup.Item>
                                        <ListGroup.Item className="col-sm-1 ps-0 pe-5 border-0 text-center">
                                          :
                                        </ListGroup.Item>
                                        <ListGroup.Item className="col-sm-4 border-0">
                                          {item.mobileOfPoc}
                                        </ListGroup.Item>
                                      </ListGroup.Item>
                                    </ListGroup>
                                    <ListGroup className="col-lg-4 mb-4">
                                      <ListGroup.Item className="d-flex border-0">
                                        <ListGroup.Item className="col-sm-4 fw-bold border-0">
                                          Business Website
                                        </ListGroup.Item>
                                        <ListGroup.Item className="col-sm-1 ps-0 pe-5 border-0 text-center">
                                          :
                                        </ListGroup.Item>
                                        <ListGroup.Item className="col-sm-4 border-0">
                                          {item.businessWebsite}
                                        </ListGroup.Item>
                                      </ListGroup.Item>
                                      <ListGroup.Item className="d-flex border-0">
                                        <ListGroup.Item className="col-sm-4 fw-bold border-0">
                                          Business Phone
                                        </ListGroup.Item>
                                        <ListGroup.Item className="col-sm-1 ps-0 pe-5 border-0 text-center">
                                          :
                                        </ListGroup.Item>
                                        <ListGroup.Item className="col-sm-4 border-0">
                                          {item.businessPhone}
                                        </ListGroup.Item>
                                      </ListGroup.Item>
                                      <ListGroup.Item className="d-flex border-0">
                                        <ListGroup.Item className="col-sm-4 fw-bold border-0">
                                          Country{" "}
                                        </ListGroup.Item>
                                        <ListGroup.Item className="col-sm-1 ps-0 pe-5 border-0 text-center">
                                          :
                                        </ListGroup.Item>
                                        <ListGroup.Item className="col-sm-4 border-0">
                                          {item.country}
                                        </ListGroup.Item>
                                      </ListGroup.Item>
                                      <ListGroup.Item className="d-flex border-0">
                                        <ListGroup.Item className="col-sm-4 fw-bold border-0">
                                          City{" "}
                                        </ListGroup.Item>
                                        <ListGroup.Item className="col-sm-1 ps-0 pe-5 border-0 text-center">
                                          :
                                        </ListGroup.Item>
                                        <ListGroup.Item className="col-sm-4 border-0">
                                          {item.city}{" "}
                                        </ListGroup.Item>
                                      </ListGroup.Item>
                                      <ListGroup.Item className="d-flex border-0 ">
                                        <ListGroup.Item className="col-sm-12 border-0">
                                          <a
                                            className="pdf-btn"
                                            href={
                                              item.businessProfile
                                                ? `${IMAGE_URL_UPLOAD}business_profile/${item.businessProfile}`
                                                : ""
                                            }
                                            target="_blank"
                                          >
                                            <svg
                                              width="23"
                                              height="25"
                                              viewBox="0 0 23 25"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <g clipPath="url(#clip0_711_20)">
                                                <path
                                                  d="M14.5485 0.928796C14.5485 2.28778 14.5485 3.64676 14.5485 5.00575C14.5485 6.09793 15.2023 6.74129 16.3122 6.74188C17.5553 6.74188 18.7982 6.74188 20.0409 6.74188H20.3182V10.7848H2.16168V10.53C2.16168 8.25711 2.182 5.98426 2.15451 3.712C2.13599 2.13524 3.31574 1.09637 4.44709 0.961609C4.46801 0.961609 4.48653 0.938757 4.50685 0.926453L14.5485 0.928796Z"
                                                  fill="white"
                                                />
                                                <path
                                                  d="M4.55786 24.9288C3.98293 24.8081 3.44684 24.6083 3.01773 24.1934C2.6895 23.8875 2.4467 23.5042 2.3125 23.0801H20.1882C20.062 23.5208 19.8098 23.877 19.4865 24.1934C19.0586 24.61 18.5219 24.8087 17.947 24.9294L4.55786 24.9288Z"
                                                  fill="white"
                                                />
                                                <path
                                                  d="M11.2514 12.2092C14.2547 12.2092 17.2583 12.2092 20.2621 12.2092C21.0659 12.2092 21.6964 12.4963 22.0496 13.2211C22.1727 13.4825 22.2377 13.7665 22.2403 14.0543C22.2558 15.9756 22.254 17.8969 22.2463 19.8182C22.2421 20.9198 21.461 21.6581 20.3117 21.6592C17.8255 21.6627 15.3397 21.6627 12.8542 21.6592C9.30821 21.6592 5.76217 21.6592 2.21613 21.6592C1.41827 21.6592 0.800301 21.3663 0.451872 20.6502C0.330645 20.3887 0.2673 20.1049 0.266005 19.8176C0.249869 17.8963 0.25226 15.975 0.259432 14.0538C0.263615 12.9797 1.01904 12.2409 2.1229 12.211C2.43367 12.2028 2.74445 12.211 3.05523 12.211L11.2514 12.2092ZM9.47635 16.9682V19.053C9.47635 19.4731 9.5905 19.6079 10.0142 19.6131C10.5551 19.6196 11.0984 19.6202 11.6374 19.5821C12.4897 19.5235 13.0407 18.9575 13.067 18.1131C13.0909 17.3567 13.0909 16.5985 13.067 15.8426C13.0419 15.0311 12.6014 14.502 11.7857 14.3965C11.151 14.3145 10.4995 14.3426 9.85645 14.3502C9.58691 14.3532 9.47575 14.5143 9.47515 14.7897C9.47515 15.5163 9.47635 16.2422 9.47635 16.9682ZM6.42476 17.727C6.83056 17.7077 7.19752 17.7059 7.56029 17.6684C7.93527 17.6308 8.28632 17.4702 8.55657 17.2125C9.05381 16.7514 9.04843 15.6551 8.80399 15.1571C8.52609 14.5922 8.01868 14.3772 7.42462 14.3473C6.86104 14.3186 6.29447 14.3315 5.7291 14.3362C5.40398 14.3362 5.27668 14.478 5.27668 14.8049C5.27668 16.2416 5.27668 17.6782 5.27668 19.1145C5.27668 19.4608 5.44581 19.6067 5.84325 19.612C6.24965 19.6172 6.42416 19.4672 6.42476 19.1092C6.42536 18.651 6.42476 18.1922 6.42476 17.727ZM14.9753 17.4C15.3136 17.4 15.6327 17.4 15.9471 17.4C16.283 17.4 16.4198 17.2764 16.4252 16.9846C16.4294 16.6776 16.2841 16.5393 15.9525 16.5375C15.6357 16.5375 15.3195 16.5375 14.9771 16.5375V15.317H15.2669C15.7767 15.317 16.2865 15.3206 16.7969 15.317C17.082 15.3141 17.2296 15.1348 17.2278 14.8137C17.2278 14.5038 17.0832 14.3397 16.8011 14.3362C16.4587 14.3321 16.1162 14.3362 15.7732 14.3362C15.2873 14.3362 14.8008 14.3315 14.3149 14.3391C13.9904 14.3444 13.8308 14.4727 13.8302 14.7317C13.8262 16.2235 13.8262 17.7155 13.8302 19.2077C13.8305 19.3069 13.8707 19.402 13.942 19.4725C14.181 19.6582 14.4583 19.6442 14.7338 19.5481C14.9861 19.4602 14.9765 19.251 14.9729 19.0436C14.9741 18.5039 14.9753 17.9661 14.9753 17.4Z"
                                                  fill="white"
                                                />
                                                <path
                                                  d="M19.9224 5.33562C18.6873 5.33562 17.4522 5.33562 16.217 5.33562C16.0736 5.33562 15.9863 5.2823 15.9863 5.13289C15.9863 3.8989 15.9887 2.66492 15.9935 1.43093C15.9935 1.42683 16.0055 1.42273 16.064 1.38464C17.3759 2.66199 18.7206 3.92351 19.9876 5.26062L19.9224 5.33562Z"
                                                  fill="white"
                                                />
                                                <path
                                                  d="M10.6411 15.3218C10.9034 15.3218 11.1497 15.3089 11.3941 15.3253C11.6893 15.3452 11.9021 15.528 11.9087 15.8163C11.9266 16.5878 11.9266 17.3597 11.9087 18.1319C11.9027 18.4067 11.7174 18.5632 11.4383 18.6118C11.3594 18.6258 11.2795 18.6332 11.1993 18.6341C11.02 18.6376 10.8359 18.6341 10.6387 18.6341L10.6411 15.3218Z"
                                                  fill="white"
                                                />
                                                <path
                                                  d="M6.4375 15.3211C6.72736 15.3211 6.9969 15.31 7.26524 15.3246C7.55151 15.3399 7.7332 15.5069 7.78639 15.7828C7.80712 15.8898 7.81654 15.9986 7.81448 16.1075C7.80552 16.6424 7.60889 16.8311 7.06025 16.8369C6.85645 16.8369 6.65265 16.8369 6.4375 16.8369V15.3211Z"
                                                  fill="white"
                                                />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_711_20">
                                                  <rect
                                                    width="22"
                                                    height="24"
                                                    fill="white"
                                                    transform="translate(0.251953 0.928772)"
                                                  />
                                                </clipPath>
                                              </defs>
                                            </svg>{" "}
                                            Business Profile
                                          </a>
                                        </ListGroup.Item>
                                      </ListGroup.Item>
                                      <UpdateBusiness
                                        id={item._id}
                                        category_id={item.category_id._id}
                                        category_name={item.category_id.name}
                                        subCategory_id={
                                          item.subcategory_id
                                            ? item.subcategory_id._id
                                            : ""
                                        }
                                        subCategory_name={
                                          item.subcategory_id
                                            ? item.subcategory_id.name
                                            : ""
                                        }
                                        name={item.companyName}
                                        nameOfPoc={item.nameOfPoc}
                                        emailOfPoc={item.emailOfPoc}
                                        mobileOfPoc={item.mobileOfPoc}
                                        businessWebsite={item.businessWebsite}
                                        businessPhone={item.businessPhone}
                                        country={item.country}
                                        city={item.city}
                                        images={item.images ? item.images : []}
                                        businessProfile={item.businessProfile}
                                        description={item.businessIntro}
                                        status={item.status}
                                        created={item.created}
                                      />
                                    </ListGroup>
                                    <ListGroup className="col-lg-4 image-slider">
                                      <ListGroup.Item className="border-0 ">
                                        {/* <ImageSlider // pass the image array to the carousel
                                                        images={images}
                                                    /> */}

                                        <Carousel>
                                          <Carousel.Item>
                                            <img
                                              className="d-block w-100"
                                              src={
                                                item.images[0] ? (
                                                item.images[0] !== "undefined"
                                                  ? item.images[0] !== "null"
                                                    ? `${IMAGE_URL_BUSINESS}${item.images[0]}`
                                                    : `${IMAGE_URL_BUSINESS}dummy_business_image.jpg`
                                                    : `${IMAGE_URL_BUSINESS}dummy_business_image.jpg`
                                                ) : (
                                                  `${IMAGE_URL_BUSINESS}dummy_business_image.jpg`
                                                )
                                              }
                                              alt="First slide"
                                            />
                                          </Carousel.Item>

                                          { item.images[1]? (
                                            item.images[1] !== "undefined" ? (
                                            item.images[1] !== "null" ? (
                                            <Carousel.Item>
                                              <img
                                                className="d-block w-100"
                                                src={`${IMAGE_URL_BUSINESS}${item.images[1]}`}
                                                alt="Second slide"
                                              />
                                            </Carousel.Item>
                                          ) : (
                                            ""
                                            )
                                          
                                          ) : ( 
                                            ""
                                          )): ""}

                                          {/* {item.images[2] == "null" ? (
                                            <Carousel.Item>
                                              <img
                                                className="d-block w-100"
                                                src={`${IMAGE_URL_BUSINESS}${item.images[2]}`}
                                                alt="Third slide"
                                              />
                                            </Carousel.Item>
                                          ) : (
                                            ""
                                          )} */}
                                          {
                                            item.images[2] ? (
                                            item.images[2] !== "undefined" ? (
                                              item.images[2] !== "null" ? (
                                                <Carousel.Item>
                                                  <img
                                                    className="d-block w-100"
                                                    src={`${IMAGE_URL_BUSINESS}${item.images[2]}`}
                                                    alt="Third slide"
                                                  />
                                                </Carousel.Item>
                                              ) : (
                                                ""
                                              )
                                            ) : (
                                              ""
                                              )) : (
                                              ""
                                            )
                                          }
                                          {/* {item.images[2] !== "undefined" ? (
                                            <Carousel.Item>
                                              <img
                                                className="d-block w-100"
                                                src={`${IMAGE_URL_BUSINESS}${item.images[2]}`}
                                                alt="Third slide"
                                              />
                                            </Carousel.Item>
                                          ) : (
                                            ""
                                          )} */}
                                          { item.images[3] ? (
                                            item.images[3] !== "undefined" ?
                                          item.images[3] !== "null" ? (
                                            <Carousel.Item>
                                              <img
                                                className="d-block w-100"
                                                src={`${IMAGE_URL_BUSINESS}${item.images[3]}`}
                                                alt="Fourth slide"
                                              />
                                            </Carousel.Item>
                                          ) : (
                                            ""
                                            )
                                              : ""
                                          ) : ""  
                                          }
                                         

                                          {item.images[4] ? (
                                            item.images[4] !== "null" ? (
                                            item.images[4] !== "undefined" ? (
                                              <Carousel.Item>
                                                <img
                                                  className="d-block w-100"
                                                  src={`${IMAGE_URL_BUSINESS}${item.images[4]}`}
                                                  alt="Fifth slide"
                                                />
                                              </Carousel.Item>
                                            ) : (
                                              ""
                                            )
                                          ) : (
                                            ""
                                          )) : ""}
                                        </Carousel>
                                      </ListGroup.Item>
                                    </ListGroup>
                                  </Row>
                                  <p className="ps-4 fw-bold mt-3">
                                    Business Intro (less than 500 characters)
                                  </p>
                                  <p className="ps-4">{item.businessIntro}</p>
                                </Accordion.Body>
                              </Accordion.Item>
                            );
                        })}

                    </Accordion>
                </Row>
            </Container>
            <Footer />
        </>
    );
}
export default RequestBusinessHistory;

